import { useQuery } from '@tanstack/react-query';
import { adminApi } from '../api/adminApi';
import { adminKeys } from '../api/adminQueryKeys';
export function useAdminUserDetail(userId) {
    return useQuery({
        queryKey: adminKeys.userDetail(userId),
        queryFn: () => adminApi.getUserDetail(userId),
    });
}
